import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { authService } from '@/services/auth.service.ts';

export function RequireAuth() {
  const location = useLocation();
  const [state, setState] = useState<'pending' | 'authed' | 'unauthed'>('pending');

  useEffect(() => {
    let cancelled = false;
    authService
      .ensureSession()
      .then((ok) => {
        if (!cancelled) setState(ok ? 'authed' : 'unauthed');
      })
      .catch(() => {
        if (!cancelled) setState('unauthed');
      });
    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  if (state === 'pending') {
    return (
      <div className="grid min-h-svh place-items-center text-sm text-slate-500">
        Loading...
      </div>
    );
  }

  if (state === 'unauthed') {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return <Outlet />;
}
